import React from 'react'
import styled from 'styled-components'
import { Button } from 'pcln-design-system'

const StyledButton = styled(Button)<{
  animatedBoxShadow: string
  scale: number
}>`
  height: 56px;
  &:hover {
    transform: scale(${props => props.scale});
    box-shadow: ${props => props.animatedBoxShadow};
    transition: 0.2s ease-in-out;
  }
`

type SearchFormButtonProps = {
  buttonText: string
  handleClick?: () => void
  [key: string]: unknown
  scale?: number
  animatedBoxShadow?: string
}
export default function SearchFormButton({
  buttonText,
  handleClick = () => {
    // empty default function
  },
  scale = 1,
  animatedBoxShadow,
  ...buttonProps
}: SearchFormButtonProps) {
  return (
    <StyledButton
      width={1}
      px={1}
      py={0}
      size="large"
      onClick={handleClick}
      type="submit"
      borderRadius="lg"
      scale={scale}
      animatedBoxShadow={
        animatedBoxShadow || buttonProps.boxShadowSize || 'none'
      }
      {...buttonProps}
    >
      {buttonText}
    </StyledButton>
  )
}
